














import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import Carga from '@/model/resource/Carga'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import Responsavel from '@/model/resource/Responsavel'
import * as Helper from '@/helpers'

@Component
export default class RenderCargaActionTrash extends Vue {
  @Getter('auth/responsavel') user!: Responsavel
  @Prop({required: true}) model!: Carga
  Helper = Helper

  DeliveryStatus = DeliveryStatus

  get showExcluirCargasFinalizadas() {
    return this.user.permitirExcluirNotasFinalizadas
  }

  openModalDelivery(items?: Carga[]) {
    const selectedItems = items
    this.$modal.open('deliveryRemove', selectedItems)
  }
}
